module.exports = __webpack_public_path__ + "img/down-arrow.61b19773.svg";